(function fullImageViewerMain(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.Event ||
    !global.NewHomeSource.FullImageViewerHeader ||
    !global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.CaptionBar ||
    !global.NewHomeSource.FilmStrip ||
    !global.NewHomeSource.ImageCounter ||
    !global.NewHomeSource.ImageViewer ||
    !global.NewHomeSource.ModalBackground ||
    !global.NewHomeSource.FullImageViewer.Config
  ) {
    return;
  }

  const previousFullImageViewerMain = global.NewHomeSource.FullImageViewerMain;
  const fullImageViewerData = JSON.parse(document.querySelector('[data-component="fullImageViewerData"]').innerHTML);
  const triggerSelector = '[data-full-image-viewer-trigger="true"]';
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();

  function close(event) {
    const container = global.NewHomeSource.FullImageViewer.Config.fullImageViewer;
    const trigger = global.document.querySelector(triggerSelector);

    if (trigger) {
      trigger.removeAttribute('data-full-image-viewer-trigger');
    }

    global.NewHomeSource.ModalBackground.destroyBackground();
    container.parentElement.removeChild(container);

    event.preventDefault();
  }

  /**
   * @private
   * onKeyDown: closes the full image viewer when the ESC key pressed.
   *
   * @param {KeyboardEvent} event with the information related to key pressed.
   */
  function onKeyDown(event) {
    if (event.keyCode !== 27) {
      return;
    }

    close(event);
  }

  const events = {
    close: {
      callbacks: [close],
      elements: '[data-full-image-viewer-role="close"]',
      events: [eventToAttach],
    },
    keyboard: {
      callbacks: [onKeyDown],
      elements: '[data-component="full-image-viewer"]',
      events: ['keydown'],
    },
  };

  /**
   * @constructs NewHomeSource.FullImageViewerMain
   */
  function FullImageViewerMain() {
    const trigger = global.document.querySelector(triggerSelector);

    global.NewHomeSource.Pipe();
    global.NewHomeSource.FullImageViewerHeader.appendInformation();
    global.NewHomeSource.FullImageViewerState.init(fullImageViewerData);
    global.NewHomeSource.FullImageViewerState.setImage(trigger);
    global.NewHomeSource.Event(events);
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewerMain to the previous script.
   */
  FullImageViewerMain.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewerMain = previousFullImageViewerMain;
    return FullImageViewerMain;
  };

  global.NewHomeSource.FullImageViewerMain = FullImageViewerMain;
}(window));
